import React from 'react'

import { carGalleryData as CData } from '../../../data/carGallery.data'

import close from './../../../UI/canvas/FichaTecnica/close.svg'


interface Props{
    isGalleryThumbsOpened: boolean
    contextualMenu: boolean,
    individualCar: string,
    handleCloseGallery: any,
    openVideo: any,
    openImage: any
}

interface State{
    carGalleryData: any
}

class GalleryThumbsMobile extends React.Component<Props,State>{
    constructor(props: Props){
        super(props);
        this.state = {
            carGalleryData: CData()
        }
    }

    handleGetThumbs = () => {
        return(
            <div className='main-gallery-thumbs-wrapper-mobile'>
                {
                    this.state.carGalleryData[0][this.props.individualCar].Galeria.map((data: any, index: number) => 
                    
                        data.isVideo ? 
                        <div className='thumb-gallery-mobile' onClick={() => {this.props.openVideo(data.src)}} key={index}>
                            <img src={data.Thumbnail}></img>
                        </div>:
                        <div className='thumb-gallery-mobile' onClick={() => {this.props.openImage(data.LargeImage)}} key={index}>
                            <img src={data.Thumbnail}></img>
                        </div>
                    
                    )
                }
            </div>
        )
    }

    render(): React.ReactNode {
        return(
            <div className={this.props.isGalleryThumbsOpened && this.props.contextualMenu ? "main-gallery-thumbs-mobile fade-in":"main-gallery-thumbs-mobile fade-out"}>
                <img className='close-btn-fichas-mobile' src={close} onClick = {() => {this.props.handleCloseGallery()}}></img>
                <div className='custom-ficha-hr-mobile'/>
                <div className='main-ficha-title-mobile'>GALERÍA</div>
                {
                    this.props.individualCar !== "" ? this.handleGetThumbs():null
                }
            </div>
        )
    }
}

export default GalleryThumbsMobile